if($('.in-blog.type-posts-listing').length){
    $('.content-inner>p').html($('footer#footer .blog-roscetnik'))
}

if($('.in-zdravi, .in-recenze, .in-jak-zacit, .in-deti-a-barefoot').length){
    $('.breadcrumbs #navigation-1').before('<span id="navigation-null" itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem"><a href="/blog/" itemprop="item"><span itemprop="name">Bosonohý blog</span></a><span class="navigation-bullet">-</span><meta itemprop="position" content="2"></span>')
}